/**
 * Selector de idioma.
 *
 * Un idioma visible cada vez y el resto disponibles, como se acordo.
 *
 * Son tres botones de verdad y no un desplegable. El `select` nativo que habia
 * antes se eligio por accesibilidad, y el argumento era bueno, pero con solo
 * tres opciones un grupo de botones gana en las dos cosas que importan aqui:
 * se cambia de idioma con UN toque en vez de dos (abrir y elegir), y se ve cual
 * esta activo sin desplegar nada. Siguen siendo controles nativos, enfocables
 * con teclado y anunciados como grupo.
 *
 * `aria-pressed` y no `aria-current`: esto no es navegacion, es un ajuste con
 * un valor activo, que es justo lo que describe un boton de dos estados.
 *
 * Visible va el codigo corto (CA, ES, EN), que es lo que cabe en la cabecera de
 * un movil; el nombre completo del idioma viaja en el rotulo accesible, para
 * que un lector de pantalla diga "Català" y no deletree "ce a".
 */

import { useTranslation } from 'react-i18next';
import { IDIOMAS, NOMBRE_IDIOMA } from '@recorregut/shared';
import { cambiarIdioma, idiomaActivo } from '@/i18n';

interface Props {
  className?: string;
}

export function SelectorIdioma({ className = '' }: Props) {
  const { t } = useTranslation();
  const actual = idiomaActivo();

  return (
    <div
      role="group"
      aria-label={t('idioma.canviar')}
      className={`inline-flex items-center gap-0.5 rounded-lg border border-crema-200 bg-white
                  p-0.5 ${className}`}
    >
      {IDIOMAS.map((idioma) => {
        const activo = idioma === actual;
        return (
          <button
            key={idioma}
            type="button"
            lang={idioma}
            aria-pressed={activo}
            aria-label={NOMBRE_IDIOMA[idioma]}
            onClick={() => {
              if (!activo) void cambiarIdioma(idioma);
            }}
            /*
              44 px explicitos y no heredados: en Tailwind 4 la capa `utilities`
              gana siempre a `base`, asi que un `min-h-[40px]` de aqui pisaba el
              minimo de 44 que declara estilos.css. Se descubrio midiendo, no
              leyendo.
            */
            className={`min-h-[44px] rounded-md px-2.5 text-xs font-semibold tracking-wide
                        uppercase transition-colors ${
                          activo
                            ? 'bg-roig-600 text-white'
                            : 'text-tinta-700 hover:bg-crema-100 hover:text-tinta-900'
                        }`}
          >
            {idioma}
          </button>
        );
      })}
    </div>
  );
}
